<template>
  <div>
    <button @click="turnOff" v-if="preference == true" class="btn btn-success">Emojies are ON</button>
    <button  @click="turnOn" v-if="preference == false" class="btn btn-danger">Emojies are OFF</button>
  </div>
</template>

<script>
  export default {
      props: ['emoji_pref'],
    data() {
      return {
        preference: this.emoji_pref,
      }
    },
    methods: {
        turnOff() {
            axios
            .get("/emoji-off")
            .then(response => (this.preference = response.data.preference))
            .catch(function(error) {
                // handle error
                console.log(error);
            });
        },
        turnOn() {
            axios
            .get("/emoji-on")
            .then(response => (this.preference = response.data.preference))
            .catch(function(error) {
                // handle error
                console.log(error);
            });
        }
    }
  }
</script>